import { UIGameBeginnerHintIndicatorView } from './UIGameBeginnerHintIndicatorView.ts';
import { UIGameBeginnerHintInformationView } from './UIGameBeginnerHintInformationView.ts';
import { bringToFront } from '../../ui_utils/PixiUtils.ts';
/**
 * @deprecated use activateBeginnerHint from gameStore instead
 */ export class UIGameBeginnerHintView {
    destroy() {
        var _this_hintInformation, _this_hintIndicator;
        (_this_hintInformation = this.hintInformation) === null || _this_hintInformation === void 0 ? void 0 : _this_hintInformation.destroy();
        (_this_hintIndicator = this.hintIndicator) === null || _this_hintIndicator === void 0 ? void 0 : _this_hintIndicator.destroy();
    }
    hideInformation() {
        this.hintInformation.visible = false;
    }
    constructor(uiGameManager, viewToPlaceAbove, descriptionText, hintIcon){
        this.hintIndicator = new UIGameBeginnerHintIndicatorView(uiGameManager, viewToPlaceAbove);
        this.hintInformation = new UIGameBeginnerHintInformationView(uiGameManager, this.hintIndicator.view, descriptionText, hintIcon);
        this.hintIndicator.view.setClickAction(()=>{
            this.hintInformation.toggleVisibility();
            this.hintIndicator.toggleAnimation(!this.hintInformation.visible);
            if (this.hintInformation.visible) bringToFront(this.hintInformation);
        });
    }
}
